import { PAGE_BUILDER_CODE_COMPONENT } from '../page-builder-components.models';

export class PageBuilderRowModel {
    static getProperties() {
        return {
            CODE: PAGE_BUILDER_CODE_COMPONENT.ROW,
            NAME: 'Ligne',
            ICON: 'table_rows',
            PROPERTIES: [
                { ID: 'TYPE_COMPONENT', CODE: PAGE_BUILDER_CODE_COMPONENT.TEXTBOX, LABEL: 'Type', DEFAULT_VALUE: 'Ligne', IS_READONLY: true },
                { ID: 'INDEX', CODE: PAGE_BUILDER_CODE_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index' },
                { ID: 'BINDING', CODE: PAGE_BUILDER_CODE_COMPONENT.DROPDOWN, LABEL: 'Binding', DS_DATAS: [], DS_VALUE_COLUMN_NAME: 'ID', DS_DISPLAY_COLUMN_NAME: 'VALUE', DEFAULT_VALUE: null },
            ]
        };
    }
}